<template>
  <div :class="`alert alert-${message.type}`">
    {{ message.text }}
    <a href="#" @click.prevent.stop="onClose" class="close">&times;</a>
  </div>
</template>

<script lang="ts">
import { Message } from "@/store/messages";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    message: {
      required: true,
      type: Object,
    },
  },
})
export default class AlertBoxItem extends Vue {
  message!: Message;

  onClose() {
    this.$store.commit("messages/removeMessage", this.message.id);
  }
}
</script>

<style lang="scss">
.alert {
  padding: 8px;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 8px;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
  .close {
    font-size: 2em;
    position: absolute;
    top: 1px;
    right: 8px;
    font-weight: normal;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  &.alert-error {
    border-color: rgb(192, 92, 92);
    background-color: rgba(192, 92, 92, 0.8);
    color: white;
  }
  &.alert-success {
    border-color: rgb(92, 192, 92);
    background-color: rgba(92, 192, 92, 0.8);
    color: white;
  }
  &.alert-info {
    border-color: rgb(92, 192, 192);
    background-color: rgba(92, 192, 192, 0.8);
    color: white;
  }
  &.alert-warn {
    border-color: rgb(255, 219, 36);
    background-color: rgba(255, 219, 36, 0.8);
    color: black;
  }
}
</style>
